export function noop(): void {}



// WEBPACK FOOTER //
// ../../../src/utils/noop.ts